import { ReactNode, Dispatch, SetStateAction } from 'react'
import { IPropsInterface } from '@fareye/ui'
import { RouteComponentProps } from 'react-router'
import {
  IPageRenderConfig,
  AtLeastOne,
  IRouteConfig,
  IKeyValueObj
} from '@fareye/types'

export enum ValidSubPages {
  inTransitPerformance = 'inTransitPerformance',
  routeDetailsPage = 'routeDetailsPage',
  transporterDetailsPage = 'transporterDetailsPage',
  allTripsPage = 'allTripsPage',
  allTransportersPage = 'allTransportersPage',
  eta = 'eta',
  multiModelListing = 'multiModelListing',
  multiModelListingCompleted = 'multiModelListingCompleted',
  'routePerformance' = 'routePerformance',
  transporterPerformance = 'transporterPerformance',
  routeDetail = 'routeDetail',
  routeDetailShipment = 'routeDetailShipment',
  multiModalTransporterDetail = 'multiModalTransporterDetail',
  containerListing = 'containerListing',
  parcelListing = 'parcelListing'
}

export interface ILayoutComponentProps<T> extends RouteComponentProps {
  config: T
  baseUrl: string
  routesConfig?: Partial<IRouteConfig>[]
}
export interface IInTransitPerformance
  extends ILayoutComponentProps<IPageRenderConfig> {}
export interface IDropdown {
  sorting: (param: string) => void
  label: string
}
export interface IRouteWiseDetails extends RouteComponentProps {
  config: IPageRenderConfig
  origin: string
  destination: string
  avgOnTimeDeliveryScore: number
  vehicleMetrics: IKeyValue<number>
  actualTransitTime: number
  targetTransitTime: number
  totalTrips: number
  startDate: string
  endDate: string
  transportMode?: any[]
  metrics?: any
  route_string?: any
}
export interface ITransporterDetails extends RouteComponentProps {
  startDate: string
  endDate: string
  config: IPageRenderConfig
  searchQuery?: any
  globalSearch?: any
}
export interface ITransportersPerformance extends RouteComponentProps {
  startDate: string
  endDate: string
  overAllFilters: IKeyValue<string>
  subFilterKey: IKeyValue<string>
  restKeys: IKeyValue<string>
  config: IPageRenderConfig
  searchQuery: any
  setSummaryFilter: (s: any) => void
}
export interface ITripTableProps extends RouteComponentProps {
  subFilter?: any[]
  style?: React.CSSProperties
  isRealTimeAlertApi?: boolean
  startDate?: string
  endDate?: string
  config: IPageRenderConfig
  columns: Array<string>
  selectedKey: string
  searchQuery: any
}

export interface ITransportersDetailsCard extends RouteComponentProps {
  config: IPageRenderConfig
  avgOnTimeDeliveryScore: any
  routes: Array<any>
  transporter: string
  vehicleMetrics: IKeyValue<number>
  transportMode?: any[]
  exceptionCount?: number
  carrier?: string
}
export interface IRouteDetails extends RouteComponentProps {
  startDate: string
  endDate: string
  config: IPageRenderConfig
  searchQuery?: any
  globalSearch?: any
}
export interface ICircularProgressChartProps {
  label: string
  percentage: number
  text: string
  labelStyle?: React.CSSProperties
}

export type IInTransitConfig = {
  readonly [key in ValidSubPages]: AtLeastOne<IPageRenderConfig>
}
export interface IRouteWisePerformance extends RouteComponentProps {
  startDate: string
  endDate: string
  config: IPageRenderConfig
  searchQuery: any
  setSummaryFilter: (n: any) => void
}

export interface IKeyValue<T> {
  [key: string]: T
}

export interface IApiFilter {
  apiURL: string
  downloadUrl?: string
  queryParams?: IKeyValue<string>
  modifyResponse?: (content: any) => any
  apiDataState?: any
  aggsFilter?: string[]
}

type FilterTypes = 'apiFilter'

type IFilter = { readonly [f in FilterTypes]: IApiFilter | any }
export interface IFilterDataFormat {
  readonly label: string
  readonly value: string
}
export interface IFilterOptions extends Partial<IFilter> {
  apiFilter?: any
  filterData?: { [key: string]: Array<IFilterDataFormat> }
  selectedFilters?: IKeyValue<string | Date | {}>
}
export interface IToggleContent {
  icon: ReactNode
  title: string
  selectedKey: string
  link?: string
}

export interface IMapComponent {
  RouteWisePerformance: ReactNode
  TransportersPerformance: ReactNode
  RouteDetails: ReactNode
  TripTable: ReactNode
  TripTableETA: ReactNode
  RouteWiseDetails: ReactNode
  TransportersDetailsCard: ReactNode
  TransporterDetails: ReactNode
  Timeline: ReactNode
  eta: ReactNode
  MultiModelPackageTimeLine: ReactNode
  ShipmentTimeLine: ReactNode
  MultiShipmentTimeline: ReactNode
  MultiModelListing: ReactNode
  TripTableMultiModel: ReactNode
  MultiModalRoute: ReactNode
  MultiModalTransporter: ReactNode
  MultiModalTableList: ReactNode
  MultiModalRouteDetails: ReactNode
  MultiModalTransporterDetails: ReactNode
  TransportersDetailsOcean: ReactNode
  ContainerListTable: ReactNode
  TripTableParcel: ReactNode
  ParcelTimeline: ReactNode
  CarrierDetailsCard: ReactNode
  ParcelCarrierPerformance: ReactNode
  ParcelCarrierDetails: ReactNode
  ParcelDetailTable: ReactNode
  ParcelRouteDetails: ReactNode
  ParcelRoute: ReactNode
  ContainerStatusTable: ReactNode
}

export interface ITimeLineLine extends IPropsInterface {
  borderColor: 'green5' | 'gray7'
  borderStyle: 'solid' | 'dotted'
}

// type TProgressNumber = 0..100;

export interface ICircularProgress {
  size: number
  textFontSize?: string
  percentage:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39
    | 40
    | 41
    | 42
    | 43
    | 44
    | 45
    | 46
    | 47
    | 48
    | 49
    | 50
    | 51
    | 52
    | 53
    | 54
    | 55
    | 56
    | 57
    | 58
    | 59
    | 60
    | 61
    | 62
    | 63
    | 64
    | 65
    | 66
    | 67
    | 68
    | 69
    | 70
    | 71
    | 72
    | 73
    | 74
    | 75
    | 76
    | 77
    | 78
    | 79
    | 80
    | 81
    | 82
    | 83
    | 84
    | 85
    | 86
    | 87
    | 88
    | 89
    | 90
    | 91
    | 92
    | 93
    | 94
    | 95
    | 96
    | 97
    | 98
    | 99
    | 100
  text?: string
}

/** Multi Model Typing */
export interface IMultiModelList extends ILayoutComponentProps<any> {}
export interface ISvgProps {
  style?: React.CSSProperties
}

export interface IColumn {
  label: string
  key: string
  formatter?: string
  columnConfig?: any
}

export interface ISelectedSummaryFilter {
  selectedFilters: IKeyValue<Array<string>>
  numberOfFiltersApplied: number
}

export interface ISelectedMoreFilter {
  selectedFilters: IKeyValue<Array<string>>
}

export interface ISummaryFilter {
  summaryData: IKeyValueObj<any>
  selectedSummaryFilter: ISelectedSummaryFilter
  setSelectedSummaryFilter: Dispatch<SetStateAction<ISelectedSummaryFilter>>
  singleSelect?: boolean
}
